import { render, staticRenderFns } from "./TableCellTypeTexteditor.vue?vue&type=template&id=6b1b55dd&scoped=true"
import script from "./TableCellTypeTexteditor.vue?vue&type=script&lang=js"
export * from "./TableCellTypeTexteditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1b55dd",
  null
  
)

export default component.exports